import { createContext, useContext, useState } from 'react'

// Create context
const ImportContext = createContext()

// Create a custom hook to access the context
export const useImport = () => useContext(ImportContext)

// Create a provider component
export const ImportProvider = ({
    children,
    title,
    details = {},
    columnTableView,
    columnNameMapping = {},
    initialPayload = {},
    downloadTemplatePayload = {},
    api = {},
    returnTitle,
    returnPath,
    onHide,
    setCompleteImport = () => {},
}) => {
    const statusSync = ['idle', 'completed', 'failed']
    const [activeStep, setActiveStep] = useState(1)
    const [payload, setPayload] = useState({ ...initialPayload, file: {} })
    const [validateData, setValidateData] = useState({})

    return (
        <ImportContext.Provider
            value={{
                title,
                details,
                columnTableView,
                columnNameMapping,
                initialPayload,
                downloadTemplatePayload,
                api,
                returnTitle,
                returnPath,
                statusSync,
                activeStep,
                validateData,
                payload,
                setPayload,
                setActiveStep,
                setValidateData,
                onHide,
                setCompleteImport,
            }}
        >
            {children}
        </ImportContext.Provider>
    )
}
